"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.doWFBillsScoutBillIncomeFlow = exports.doWFBillsScout = void 0;
const immutable_1 = require("immutable");
const redux_actions_1 = require("redux-actions");
const root_ui_1 = require("companion-app-components/flux/root-ui");
const types_1 = require("./types");
exports.doWFBillsScout = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), () => root_ui_1.rootUiTypes.mkRootUiData({
    id: 'DIALOG_WEBFIRST_BILLS_SCOUT',
    type: types_1.DIALOG_TYPE,
    allowNesting: false,
}));
exports.doWFBillsScoutBillIncomeFlow = (0, redux_actions_1.createAction)(root_ui_1.rootUiActions.createDialog.toString(), (payload) => root_ui_1.rootUiTypes.mkRootUiData({
    id: 'DIALOG_WEBFIRST_BILLS_SCOUT_INCOME_FLOW',
    type: types_1.DIALOG_TYPE,
    allowNesting: false,
    props: (0, immutable_1.Map)(Object.assign(Object.assign({}, payload), { billsIncomeFlow: true })),
}));
